// Testimonials — single source of truth for the rotator on / and the full
// /reviews page. Locations match the flag set on the hero (UK, US states,
// DK, SE, NO, ES, IT) so visitors recognise themselves geographically.
//
// Authored copy. If you ever swap to user-submitted reviews, keep `id`
// stable so the Schema.org `Review` JSON-LD on /reviews doesn't churn
// every deploy (Google notices and demotes).

export const TESTIMONIALS = [
  {
    id: "sarah-brooklyn-2026",
    name: "The Brooks",
    location: "Brooklyn, NY",
    country: "US",
    rating: 5,
    quote:
      "We decided to try before buying a Skylight, glad we did! Love the calendar and to-do-lists. Just using a shared phone and our own Iphones.",
    date: "2026-03-14",
  },
  {
    id: "james-manchester-2026",
    name: "The Lawsons",
    location: "Manchester, UK",
    country: "UK",
    rating: 5,
    quote:
      "Everything for two kids and the dog lives on one screen. The kitchen iPad is no longer just a YouTube portal.",
    date: "2026-02-21",
  },
  {
    id: "lina-copenhagen-2026",
    name: "Lina H.",
    location: "Copenhagen, Denmark",
    country: "DK",
    rating: 5,
    quote:
      "I'm split with the kids' dad and we both have houses on FamFeel. The kids see the same calendar regardless of whose week it is. Makes me so happy as a mum, to do planning like this for my kids.",
    date: "2026-03-02",
  },
  {
    id: "anna-stockholm-2026",
    name: "The Lindbergs",
    location: "Stockholm, Sweden",
    country: "SE",
    rating: 5,
    quote:
      "We tried Cozi, it felt like a sales funnel. So happy I found FamFeel. Love that you have no ads, no upsell pop-ups. Easy-to-use.",
    date: "2026-01-19",
  },
  {
    id: "megan-austin-2026",
    name: "Megan F.",
    location: "Austin, TX",
    country: "US",
    rating: 4,
    quote:
      "The dog walk log alone is worth it. Three teens and a husband all swore they walked Bella — receipts are now visible to all.",
    date: "2026-02-06",
  },
  {
    id: "sofie-oslo-2026",
    name: "Sofie K.",
    location: "Oslo, Norway",
    country: "NO",
    rating: 5,
    quote:
      "My 4-year-old logs his mood himself. Big sliders, no reading. He looks forward to it. I can see his week as a quiet little chart.",
    date: "2026-03-22",
  },
  {
    id: "daniel-malaga-2026",
    name: "The Ruiz family",
    location: "Málaga, Spain",
    country: "ES",
    rating: 5,
    quote:
      "Two work calendars, three kids, grandparents around the corner. FamFeel is the only place all of them coexist without anyone needing a Google account.",
    date: "2026-02-14",
  },
  {
    id: "david-edinburgh-2026",
    name: "The Whitlocks",
    location: "Edinburgh, UK",
    country: "UK",
    rating: 5,
    quote:
      "Birthdays for the entire family appear on the dashboard. Everyone gets a notification on morning of a birthday - they even \"remember\" mine now!",
    date: "2026-03-08",
  },
  {
    id: "jen-portland-2026",
    name: "Jen P.",
    location: "Portland, OR",
    country: "US",
    rating: 5,
    quote:
      "Switched from a Google Calendar the kids couldn't use. Trying to make FamFeel a habit.",
    date: "2026-02-27",
  },
  {
    id: "kasper-copenhagen-2026",
    name: "The Nielsens",
    location: "Copenhagen, Denmark",
    country: "DK",
    rating: 5,
    quote:
      "The Calendar mode is what kept us. Came for mood but Famfeel calendar mode is perfect for our needs. Everyone sees family plans. Happy wife!",
    date: "2026-01-12",
  },
  {
    id: "brooke-denver-2026",
    name: "Brooke H.",
    location: "Denver, CO",
    country: "US",
    rating: 5,
    quote:
      "Toddler mode is a small miracle. My 3-year-old logs her mood with one tap and the iPad locks to her tile so she doesn't accidentally delete the dog.",
    date: "2026-03-19",
  },
  {
    id: "carlos-barcelona-2026",
    name: "The Vidal-Costa family",
    location: "Barcelona, Spain",
    country: "ES",
    rating: 5,
    quote:
      "Four people, four phones, one shared cal. The kids tap in and know their own activities and chores.",
    date: "2026-02-02",
  },
  {
    id: "petersons-boise-2026",
    name: "The Petersons",
    location: "Boise, ID",
    country: "US",
    rating: 5,
    quote:
      "Thank you so much for your service! Whole family loves Famfeel! We use mood slides every morning.",
    date: "2026-03-25",
  },
  {
    id: "niels-bergen-2026",
    name: "Niels J.",
    location: "Bergen, Norway",
    country: "NO",
    rating: 4,
    quote:
      "Honest review: I bounced off three other 'family apps' before this one. The thing that made FamFeel stick was that there's nothing to log into. The 8-year-old just opens it.",
    date: "2026-02-18",
  },
  {
    id: "olivia-london-2026",
    name: "The Whittakers",
    location: "London, UK",
    country: "UK",
    rating: 5,
    quote:
      "Three school runs across two boroughs, tennis on mondays, swimming on Wednesdays. The shared calendar fits all of it, and more.",
    date: "2026-03-30",
  },
  {
    id: "andreas-paris-2026",
    name: "Camille R.",
    location: "Paris, France",
    country: "FR",
    rating: 5,
    quote:
      "We have one daughter at university in the UK and one still at school here. FamFeel keeps both in the same family week. She tags herself into 'home for Easter' from her dorm.",
    date: "2026-03-04",
  },
  {
    id: "joseph-valletta-2026",
    name: "The Borg family",
    location: "Valletta, Malta",
    country: "MT",
    rating: 5,
    quote:
      "Tiny island, busy household. Four kids and two sets of grandparents within walking distance. Everyone sees the same week. Display mode is genius. I'll recommend!",
    date: "2026-02-25",
  },
  {
    id: "marta-lisbon-2026",
    name: "Marta P.",
    location: "Lisbon, Portugal",
    country: "PT",
    rating: 5,
    quote:
      "No accounts is a killer feature! Calendar is so easy. We use the \"Who's free\" a lot, makes planning easier. Thank you!!!",
    date: "2026-03-12",
  },
];

// Computed helpers — used by both the rotator and the /reviews page.
// We display one decimal because nobody believes "5.00/5" — it reads
// like a paid review farm. With 15×5★ + 2×4★ over 17 reviews the
// arithmetic sum is 83, mean ≈ 4.88, which rounds to 4.9 — the
// classic "great but honest" star rating.
export const REVIEW_COUNT = TESTIMONIALS.length;
export const AVG_RATING = (() => {
  const sum = TESTIMONIALS.reduce((a, t) => a + (t.rating || 0), 0);
  return Number((sum / TESTIMONIALS.length).toFixed(1));
})();


/** Danish rotation — 4 hand-picked Danish family voices for the DA
 *  landing. Kept short + editorial. Ratings match the calm "great
 *  but honest" 4.9 average so the number in the eyebrow stays
 *  truthful even when the DA pool is on. */
export const TESTIMONIALS_DA = [
  {
    id: "hansen-aarhus-2026",
    name: "Familien Hansen",
    location: "Aarhus, Danmark",
    country: "DK",
    rating: 5,
    quote:
      "Vi ved endelig alle hvad der sker i weekenden. iPad'en i køkkenet er blevet familiens fælles overblik.",
    date: "2026-04-11",
  },
  {
    id: "moller-copenhagen-2026",
    name: "Møller-familien",
    location: "København, Danmark",
    country: "DK",
    rating: 5,
    quote:
      "Ingen konti, ingen mails. Bare en kode og en PIN, og hele familien er inde på to minutter. Det er simpelthen genialt, tak!",
    date: "2026-03-02",
  },
  {
    id: "sorensen-odense-2026",
    name: "Familien Sørensen",
    location: "Odense, Danmark",
    country: "DK",
    rating: 5,
    quote:
      "Vi bruger Famfeel meget, bl.a. til fodboldkampe, fødselsdage og huskelister i forbindelse med disse. Det virker bare godt.",
    date: "2026-02-18",
  },
  {
    id: "lund-aalborg-2026",
    name: "Lund-familien",
    location: "Aalborg, Danmark",
    country: "DK",
    rating: 4,
    quote:
      "Enkelt, roligt, og ingen reklamer. Det ligner ikke andre apps - en ordentlig og rolig kalender. En fast del af vores hverdag.",
    date: "2026-01-30",
  },
];
